export const CopyIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="56"
            height="56"
            viewBox="0 0 56 56"
            fill="none"
        >
            <path
                fill="#73A5D8"
                d="M17.115 17.437c.628-.43 1.385.093 1.385.854 0 .393-.217.747-.523.996A3.993 3.993 0 0 0 16.5 22.39v22a6 6 0 0 0 6 6h16c1.232 0 2.334.135 3.067-.508.296-.259.64-.492 1.034-.492.76 0 1.288.771.79 1.346-1.088 1.255-2.873 1.654-4.891 1.654h-16a8 8 0 0 1-8-8v-22a5.993 5.993 0 0 1 2.615-4.954ZM43.5 11.391a6 6 0 0 1 5.992 5.692l.008.308v7.654h-2V17.39a4 4 0 0 0-4-4h-18a4 4 0 0 0-4 4v24a4 4 0 0 0 4 4h18a4 4 0 0 0 4-4v-8.215h2v8.215a6 6 0 0 1-6 6h-18a6 6 0 0 1-6-6v-24l.008-.308A6 6 0 0 1 25.5 11.39h18Z"
            />
        </svg>
    );
};
